"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseTriggerStyles = exports.baseContentStyles = exports.StyledTrigger = exports.StyledContent = exports.StyledArrow = void 0;
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _variables = require("../../styles/variables");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// shared with HBMenuSubMenu
var baseTriggerStyles = exports.baseTriggerStyles = (0, _styledComponents.css)(["border:0;padding:0;background:none;&:hover,&:focus{background:none;}&:focus-visible{outline:none !important;}&[disabled]{cursor:not-allowed;}"]);
var baseContentStyles = exports.baseContentStyles = (0, _styledComponents.css)(["border-radius:2px;box-shadow:", ";background:", ";padding:8px 0;font-family:ProximaNova;"], "0 14px 28px 0 ".concat(_colors["default"].blue_015, ", 0 0 10px 0 ").concat(_colors["default"].blue_008), _colors["default"].white);
var StyledTrigger = exports.StyledTrigger = (0, _styledComponents["default"])(_reactDropdownMenu.Trigger).withConfig({
  displayName: "HBMenustyles__StyledTrigger",
  componentId: "sc-1moq0g3-0"
})(["", ""], baseTriggerStyles);
var StyledContent = exports.StyledContent = (0, _styledComponents["default"])(_reactDropdownMenu.Content).withConfig({
  displayName: "HBMenustyles__StyledContent",
  componentId: "sc-1moq0g3-1"
})(["", " ", ";max-width:", ";max-height:", ";overflow-y:auto;min-width:200px;min-height:50px;z-index:", ";&[style*='opacity: 0'],&[style*='opacity:0']{display:none;}"], baseContentStyles, function (props) {
  return !props.$withArrow && "margin-top: 4px";
}, function (_ref) {
  var $maxWidth = _ref.$maxWidth;
  return $maxWidth;
}, function (_ref2) {
  var $maxHeight = _ref2.$maxHeight;
  return $maxHeight;
}, _variables.Z_INDEX.MENU);

// TODO: arrow box shadow?
var StyledArrow = exports.StyledArrow = (0, _styledComponents["default"])(_reactDropdownMenu.Arrow).attrs({
  width: 16,
  height: 8,
  fill: _colors["default"].white
}).withConfig({
  displayName: "HBMenustyles__StyledArrow",
  componentId: "sc-1moq0g3-2"
})([""]);
//# sourceMappingURL=HBMenu.styles.js.map